export default class CommandArgGroupInfoFuncUtil
{
    static getCurrentRecord()
    {
        if(!this.currentRecord)return null;
        if(!this.groupAlias)return null;
        let obj = this.currentRecord[this.groupAlias];
        return obj;
    }

    static getCurrentMap()
    {
        if(!this.currentRecord)
            return null;
        let obj = this.currentRecord[this.groupAlias];
        if(!obj)
            return null;
        return obj;
    }

    static getSelectedRecordsByCurrentRecord()
    {
        if(this.hasColumnAsSysSelectRecords)
        {
            return [];
        }

        let record = this.getCurrentRecord();
        if(!record)return [];

        return [record];
    }

    static getSelectedMapsByCurrentRecord()
    {
        return this.getSelectedRecordsByCurrentRecord();
    }

    static getSelectedRecords()
    {
        if(!this.selectedRecords || this.selectedRecords.length == 0)
            return this.getSelectedRecordsByCurrentRecord();
        return this.selectedRecords;
    }

    static getSelectedMaps()
    {
        return this.getSelectedRecords();
    }

    static getAllRecords()
    {
        if(!this.allRecords || this.allRecords.length == 0)
            return [];
        return this.allRecords;
    }

    static getAllMaps()
    {
        return this.getAllRecords();
    }

    static getCurrentQuery()
    {
        return this.currentQuery;
    }

    static getFormQuery()
    {
        return this.formQuery;
    }
}


// WEBPACK FOOTER //
// ./src/utils/CommandArgGroupInfoFuncUtil.js